import type { SVGProps } from 'react';

function List(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.5 8H21.5C22.1 8 22.5 7.6 22.5 7C22.5 6.4 22.1 6 21.5 6H7.5C6.9 6 6.5 6.4 6.5 7C6.5 7.6 6.9 8 7.5 8ZM21.5 11H11.5C10.9 11 10.5 11.4 10.5 12C10.5 12.6 10.9 13 11.5 13H21.5C22.1 13 22.5 12.6 22.5 12C22.5 11.4 22.1 11 21.5 11ZM21.5 16H15.5C14.9 16 14.5 16.4 14.5 17C14.5 17.6 14.9 18 15.5 18H21.5C22.1 18 22.5 17.6 22.5 17C22.5 16.4 22.1 16 21.5 16ZM3.5 6C2.9 6 2.5 6.4 2.5 7C2.5 7.6 2.9 8 3.5 8C4.1 8 4.5 7.6 4.5 7C4.5 6.4 4.1 6 3.5 6ZM7.5 11C6.9 11 6.5 11.4 6.5 12C6.5 12.6 6.9 13 7.5 13C8.1 13 8.5 12.6 8.5 12C8.5 11.4 8.1 11 7.5 11ZM11.5 16C10.9 16 10.5 16.4 10.5 17C10.5 17.6 10.9 18 11.5 18C12.1 18 12.5 17.6 12.5 17C12.5 16.4 12.1 16 11.5 16Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default List;
